import { Button } from 'react-bootstrap';

const ButtonSubmit = ({ children, ...props }) => {
  return (
    <Button
    type='submit'
      {...props}
      style={{
        backgroundColor: 'rgb(132, 0, 39)',
        border: 'none',
        color: 'white',
        padding: '10px 20px',
        cursor: 'pointer',
        transition: 'background-color 0.3s',
      }}
      onMouseOver={(e) => (e.currentTarget.style.backgroundColor = 'rgb(155, 0, 45)')}
      onMouseOut={(e) => (e.currentTarget.style.backgroundColor = 'rgb(132, 0, 39)')}
    >
      {children}
    </Button>
  );
};

export default ButtonSubmit;